import {
  deserify,
  ImageWrapper,
  LinkButton,
  pxToRem,
  pxTovW,
  theme,
} from '@geneo2-web/shared-ui';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { QUESTION_PAPERS_LIST } from '../../../routeHandling/RoutesNomenclature';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setQuestionPaperData } from '../reducer/homeDashboard.slice';
import { useAppSelector } from '../../../reduxStore/reduxHooks';
import { QuestionPaperType } from '@protos/content_management/content.db_pb';

export const PreviousYearQPCard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { question_paper_data } = deserify(
    useAppSelector((state) => state.homeDashboard)
  );

  // ------------------------------------------------------------

  const cardClickHandler = () => {
    dispatch(
      setQuestionPaperData({
        ...question_paper_data,
        selected_tab: QuestionPaperType.PREVIOUS_YEAR,
      })
    );
    navigate(QUESTION_PAPERS_LIST);
  };

  // ------------------------------------------------------------

  return (
    <Box
      onClick={cardClickHandler}
      sx={{
        width: '100%',
        position: 'relative',
        paddingX: { xs: pxToRem(10), md: pxTovW(0) },
        marginTop: { xs: pxToRem(20), md: pxTovW(40) },
        boxSizing: 'border-box',
        cursor: 'pointer',
      }}
    >
      <ImageWrapper
        name="person-reading-paper"
        type="png"
        parentFolder="illustrations"
        styles={{
          width: '100%',
          height: { xs: pxToRem(88), md: pxTovW(290) },
          display: 'block',
        }}
      />

      <Box
        sx={{
          position: 'absolute',
          top: { xs: '55%', md: '50%' },
          left: { xs: '42%', md: '35%' },
          transform: 'translate(-50%, -50%)',
          width: { xs: '65%', md: pxTovW(770) },
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: pxToRem(3), md: pxTovW(10) },
          paddingX: { xs: pxToRem(20), md: pxTovW(0) },
        }}
      >
        <Typography
          variant="h2"
          textAlign="left"
          fontWeight="bold"
          sx={{ fontSize: { xs: pxToRem(12), md: pxTovW(32) } }}
        >
          Previous Year Question Papers & Sample Papers for Your Class
        </Typography>
        <Typography
          variant="h3"
          textAlign="left"
          sx={{ fontSize: { xs: pxToRem(10), md: pxTovW(24) } }}
        >
          Download and share exam-ready question papers to simplify your lesson
          prep.
        </Typography>
        <LinkButton
          dataId="explore_question_papers_and_download"
          textColor="primary.main"
          // onClick={cardClickHandler}
          typoStyle={{
            fontSize: { xs: pxToRem(8), md: pxTovW(21) },
            fontWeight: { xs: '500', md: '800' },
          }}
          rootStyle={{ width: 'max-content', p: '0' }}
        >
          Explore Question Papers & Download
        </LinkButton>
      </Box>
    </Box>
  );
};
